import { request } from '../../lib/request_saas';
import { request as requestNoformat } from '../../lib/request_noformat';

/**
 * @description 登录校验接口,如果状态码为 status:999
 * @description {
 *  "status": 999,
 *  "location": "https://member.yun300.cn/bm/oauth?client_id=c1&response_type=code&redirect_uri=https%3A%2F%2Ftest-m1.yun300.cn%3A9090%2Fnpgw%2Flocal%2Fcms%2FgetSaasTenantInfo%3F1620614062410%26viewType%3D1%26instance%3DNEW2021040113505083460%26_d%3D1620614062410"
 *  }
 * @param {Object} params
 * @returns
 */
export function getSaasTenantInfo() {
    return request({
        url: '{#npgw}/local/cms/getTenantInfo',
        method: 'post',
        // data: {
        // viewType: 1, // 设备类型 1、PC 2、手机
        // [tokenType]: accessTestInstance, // 2021年5月18日晚上，确定为动态值
        // _d: new Date().getTime(), // 时间戳
        // },
        // prop: {
        // viewType: {
        //     type: 'number',
        //     required: true,
        //     message: 'not null',
        // },
        // 2021年5月18日晚上，确定为动态值
        // [tokenType]: {
        //     type: 'string',
        //     required: true,
        //     message: 'not null',
        // },
        // _d: {
        //     type: 'number',
        //     required: true,
        //     message: 'not null',
        // },
        // },
    });
}
// pwa环境实现7天免密 更换token接口
const isInStandaloneMode = () =>
    (window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');

export function getToken() {
    return request({
        url: isInStandaloneMode() ? '{#npgw}/local/current/pwa/usertoken' : '{#npgw}/local/current/usertoken',
        method: 'get',
    });
}
export function getEnv() {
    return request({
        url: '{#npgw}/local/getEnv',
        method: 'get',
    });
}

/**
 * 用户信息: local/getLoginUser.do
 * @return {
 *  "status":200,
 *  "msg":"success",
 *  "success":true,
 *  "data":{
 *      "tenantId":1600089085,
 *      "user":{
 *          "account":"370", // 账号Id
 *          "cusId":"02ldJvXOJ9GEHmQTdhsLto", // 当前账号的客户id
 *          "custTel":null, // 客户电话
 *          "isSuper":"0", // 登录类型 0 超级管理员，1 属于普通管理员
 *          "memberCode":"SUPER_ADMIN_839921603931275264", // 显示名称
 *          "platform":"mh", // 会话渠道
 *          "traceability":2 // 登录来源溯源
 * 
//  * DESIGN(0 , "design", "设计器登录"),
// CE(1, "cecenter", "会员中心登录"),
// BM(2, "bmcenter", "B端会员登录"),
// CMS(3, "cmscenter", "CMS会员登录"),
// CMS_DESIGN(4, "design", "CMS设计云登录"),
// CMS_DWS(5, "dws", "CMS_DWS登录"),
// CMS_SOP(7, "sop", "CMS_Sop登录"),
// CE_EVENT(6, "ce_event", "中企事件系统登录"),
// SEO_SERVICE(8, "seo_service", "SEO系统登录"),
// SEO_APP(9, "seo_app", "SEO应用系统登录"),
// PWA_APP(10, "pwa_app", "pwa客户端登录"),
// NOLOGIN(-1, "nologin", "无任何登录状态")
 *      }
 *  }
 * }
 */
export function getSaasLoginUser() {
    return request({
        url: '{#npgw}/local/cms/getLoginUser',
        method: 'get',
        // 2021年5月18日晚上，确定为动态值
        // params: {
        // [tokenType]: accessTestInstance,
        // },
        // prop: {
        //     [tokenType]: {
        //         type: 'string',
        //         required: true,
        //         message: 'not null',
        //     },
        // },
    });
}

// 账号角色 通过用户id查询权限信息
export function getSaasLogout(data) {
    // 使用返回无拦截请求接口
    return requestNoformat({
        url: '{#npgw}/bm/logout',
        method: 'post',
        prop: {
            bmloginout: {
                type: 'string',
                required: true,
                message: 'bmloginout not null',
            },
        },
        data,
    });
}

// 获取网站列表
export function getCustTenant() {
    return request({
        url: '{#npgw}/cmstenant/tenant/custTenantByInstanceOrTenantId',
        method: 'get',
    });
}

export function sendUrl(url) {
    return request({
        url: url,
        method: 'get',
        dataType: 'html',
    });
}


/**
 * 获取租户信息 数字门户
 * post
 * **/
export const getTenantInfo = (data) => {
    return request({
        url: `{#npgw}/local/cms/getTenantJsonInfo`,
        method: 'POST',
        data
    })
}